import { useMutation } from '@tanstack/react-query';
import { useShowErrorToast } from '@utils/formHelpers';
import { queryFetch } from '@services/api';
import { DefaultApiResp } from '@root/globalTypes';
import { useAppContext } from '@contexts/app';
import { localStore } from '@utils/localStore';

export const useExitImpersonateUser = ({ callback }: { callback: () => void }) => {
  const { id } = useAppContext();

  const { showErrorToast } = useShowErrorToast();

  const { mutate, isPending } = useMutation({
    mutationFn: (): Promise<DefaultApiResp> => {
      localStore.setItem('app-impersonate-exiting', String(true));
      return queryFetch({
        url: ['resources/users', id, 'exit_impersonate'].join('/'),
        opt: { method: 'PUT' },
      });
    },
    onError: (err) => {
      localStore.removeItem('app-impersonate-exiting');
      console.error(err);
    },
    onSettled: (data) => {
      if (!data) return;
      const { success, errors } = data as DefaultApiResp;
      if (errors) {
        showErrorToast(errors);
        localStore.removeItem('app-impersonate-exiting');
      }
      if (success) {
        localStore.removeItem('app-user');
        localStore.removeItem('app-impersonate');
        localStore.removeItem('app-href');
        callback();
      }
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
